package uz.ferro.erp.feature.appuser.model

enum class Permission(val displayName: String? = null) {
    ADD_NEW_CUSTOMER("Yangi mijoz qo‘shish",),
    EDIT_CUSTOMER_INFO("Mijoz ma’lumotlarini o‘zgartirish"),
    ALLOW_ALL_STORES("Barcha do‘konlar bilan ishlash"),
    ALLOW_GOOD_MOVEMENTS_REQUEST("Tovar ko‘chirishga buyurtma berish"),
    ALLOW_GOOD_MOVEMENTS("Tovar ko‘chirish")
}